import { render, staticRenderFns } from "./purchase-value-propositions.vue?vue&type=template&id=7293f100&"
import script from "./purchase-value-propositions.vue?vue&type=script&lang=js&"
export * from "./purchase-value-propositions.vue?vue&type=script&lang=js&"
import style0 from "./purchase-value-propositions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports